<template>
  <section class="gr-footer-cta">
    <div class="gr-container gr-footer-cta__inner">
      <h2 class="gr-footer-cta__title">
        Mari Jadi Bagian Dari Kegiatan Positif yang Berdampak Pada Masyarakat
      </h2>
      <div class="gr-footer-cta__actions">
        <NuxtLink
          v-if="!$auth.isAuthenticated"
          to="/auth?type=signup"
          class="gr-btn gr-btn--solid gr-footer-cta__primary"
        >
          <v-icon icon="mdi-account-plus" size="18" aria-hidden="true" />
          Bergabung Sekarang
        </NuxtLink>
        <NuxtLink
          v-else
          to="/activities"
          class="gr-btn gr-btn--solid gr-footer-cta__primary"
        >
          <v-icon icon="mdi-calendar-check" size="18" aria-hidden="true" />
          Cari aktivitas
        </NuxtLink>
        <NuxtLink
          v-if="!$auth.isAuthenticated"
          to="/activities"
          class="gr-footer-cta__secondary"
        >
          <v-icon icon="mdi-calendar-check" size="18" aria-hidden="true" />
          Lihat Kegiatan
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<style scoped>
.gr-footer-cta {
  position: relative;
  isolation: isolate;
  background-color: #14351a;
  background-image: url("/assets/images/banner-footer.jpeg");
  background-position: center;
  background-size: cover;
  /* No background-attachment: fixed — it janks on mobile and the canonical
     page already had to disable it below 600px. */
}

.gr-footer-cta::before {
  position: absolute;
  inset: 0;
  z-index: -1;
  background-color: rgba(12, 26, 14, 0.72);
  content: "";
}

.gr-footer-cta__inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-block: clamp(3.5rem, 2.5rem + 4vw, 6rem);
}

.gr-footer-cta__title {
  max-width: 22ch;
  margin: 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.42);
  color: #ffffff;
  font-size: clamp(1.3rem, 1.05rem + 1.5vw, 2.25rem);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  text-wrap: balance;
  overflow-wrap: anywhere;
}

.gr-footer-cta__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 24px;
  margin-top: 2rem;
}

.gr-footer-cta__primary {
  border-color: rgba(255, 255, 255, 0.9);
}

.gr-footer-cta__primary:focus-visible,
.gr-footer-cta__secondary:focus-visible {
  outline: 3px solid #ffffff;
  outline-offset: 2px;
}

.gr-footer-cta__secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding-inline: 4px;
  color: #ffffff;
  font-size: 0.9375rem;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (hover: hover) {
  .gr-footer-cta__secondary:hover {
    text-decoration-thickness: 2px;
  }
}
</style>
